require('./profile-template.html');

angular.module('bbl.module.profile.controller', [])
  .controller('ProfileController', [
    '$scope', '$timeout', '$window', '$http', 'Auth', 'profile', 'permissions', 'Toast', 'Api',
    ProfileController
  ]);

function ProfileController($scope, $timeout, $window, $http, Auth, profile, permissions, Toast, Api) {
  $scope.image = undefined;
  $scope.timezones = [];

  $scope.bridgeLines = [];
  $scope.desktopNotificationGrant = false;

  $http.get('/bridges/timezones').then(function(result){
    $scope.timezones = result.data.timezones;
  });

  $scope.profile = profile;

  $scope.permission_level = permissions;
  if ($scope.permission_level != 3) {
    $("#company").attr("disabled", true);
  }

  Api.notifications.list().then(function(response){
    $scope.bridgeLines = response.objects;
  });

  // check if desktop notification has permission
  $scope.desktopNotificationLevel = Notify.permissionLevel;
  $scope.hasPermission = !Notify.needsPermission;


  function getNotifcationById(id){
    for (var i=0;i<$scope.bridgeLines.length;i++){
      var line = $scope.bridgeLines[i];
      if(line.id === id){
        return line;
      }
    }

    return false;
  }
  $scope.updateProfile = function(){
    if (!$scope.profile.first_name) {
      Toast.error("{{'Please complete the field'|translate}} {{'first name'|translate}}");
    }

    else if (!$scope.profile.last_name) {
      Toast.error("{{'Please complete the field'|translate}} {{'last name'|translate}}");
    }

    else if (!$scope.profile.email) {
      Toast.error("{{'Please complete the field'|translate}} {{'e-mail'|translate}}");
    }

    else if (!$scope.profile.company) {
      Toast.error("{{'Please complete the field'|translate}} {{'company'|translate}}");
    }

    else {
      Auth.setProfile($scope.profile)
        .then(Toast.notify.bind(Toast, "{{'Settings updated successfully'|translate}}"));
    }
  };


  $scope.uploadFile = function(files) {
    var fd = new $window.FormData();
    fd.append("file", files[0]);

    var uploadUrl = "/accounts/api/v1/update-profile/";

    $http.post(uploadUrl, fd, {
      transformRequest: angular.identity,
      headers : {'Content-Type': undefined}
    }).success().error(function(data, status, headers, config) {
      console.log(data);
      console.log(status);
      console.log(headers);
      console.log(config);
    });
  };

  $scope.updateNotification = function(id){
    var notify = getNotifcationById(id);
    if(notify){
      //call update
      Api.notifications.update(id, notify);
    }
  };

  var onPermission = function(hasPermission) {
    $timeout(function(){
      $scope.desktopNotificationLevel = hasPermission ? 'granted' : 'denied';
      $scope.hasPermission = hasPermission;
    });
  };

  $scope.requestPermission = function() {
    if(!Notify.isSupported()) {
      onPermission(false);
    }

    console.log($scope.hasPermission);
    if(!$scope.hasPermission) {
      Notify.requestPermission(onPermission.bind(null, true), onPermission.bind(null, false));
    }
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/profile/profile.controller.js
 ** module id = 356
 ** module chunks = 0
 **/